import { Grid, IconButton, Tooltip } from '@mui/material';
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import LinkIcon from '@mui/icons-material/Link';
import { downloadFile } from '../../../../../../../shared/utils/files';
import { PqrAttachmentActionsProps } from './props';

export const PqrAttachmentActions = ({
    attachment,
}: PqrAttachmentActionsProps) => {
    return (
        <Grid textAlign="left" width="100%">
            <Tooltip title="Descargar">
                <IconButton
                    size="small"
                    onClick={() =>
                        attachment.url &&
                        downloadFile(attachment.url, attachment.name)
                    }
                >
                    <CloudDownloadIcon color="warning" />
                </IconButton>
            </Tooltip>
        </Grid>
    );
};

export const PqrAttachmentActionsLast = ({
    attachment,
}: PqrAttachmentActionsProps) => {
    return (
        <Grid textAlign="left" width="100%">
            <Tooltip title="ir">
                <IconButton
                    size="small"
                    onClick={() =>
                        attachment.url && window.open(attachment.url, '_blank')
                    }
                >
                    <LinkIcon color="warning" />
                </IconButton>
            </Tooltip>
        </Grid>
    );
};
